import React from 'react';
import { Skeleton } from '@attain-sre/attain-design-system';
import * as Styled from './ChartLoading.styles';

// Generate static heights outside component to persist across re-renders/remounts
const SIZE_VALUES = Array.from(
  { length: 10 },
  () => Math.floor(Math.random() * 90) + 10
);

const SIZE_VALUES_2 = Array.from(
  { length: 10 },
  () => Math.floor(Math.random() * 90) + 10
);

interface ChartLoadingProps {
  barOrientation?: 'horizontal' | 'vertical';
  bothAxes?: boolean;
  chartType?: 'bar' | 'scatter';
}

const ChartLoading = ({
  barOrientation = 'vertical',
  bothAxes = false,
  chartType = 'bar',
}: ChartLoadingProps) => {
  return (
    <Styled.Wrapper $bothAxes={bothAxes}>
      <Styled.LegendLeft>
        <Skeleton variant="rounded" width={16} height={100} />
      </Styled.LegendLeft>

      {bothAxes && (
        <Styled.LegendRight>
          <Skeleton variant="rounded" width={16} height={100} />
        </Styled.LegendRight>
      )}

      <Styled.LegendBottom>
        <Skeleton variant="rounded" width={100} height={16} />
      </Styled.LegendBottom>

      <Styled.ChartWrapper
        $barOrientation={barOrientation}
        $bothAxes={bothAxes}
        $chartType={chartType}
      >
        {SIZE_VALUES.map((value, i) =>
          chartType === 'bar' ? (
            <Skeleton
              variant="rounded"
              key={i}
              style={{
                height: barOrientation === 'horizontal' ? `5%` : `${value}%`,
                width: barOrientation === 'horizontal' ? `${value}%` : `5%`,
              }}
            />
          ) : (
            <Skeleton
              variant="circular"
              key={i}
              style={{
                aspectRatio: '1/1',
                height: 'auto',
                position: 'absolute',
                translate: `-50% -50%`,
                top: `${value}%`,
                left: `${SIZE_VALUES_2[i]}%`,
                width: `${value / 12}%`,
              }}
            />
          )
        )}
      </Styled.ChartWrapper>
    </Styled.Wrapper>
  );
};

export default React.memo(ChartLoading);

